import { React, PropTypes, UI, TextField, useIntl, useSelector, isSubmittingSelector } from '../../dependencies';

const { InputWrapper } = UI;

const CityField = ({ formId, ...rest }) => {
    const intl = useIntl();
    const submitting = useSelector(isSubmittingSelector(formId));

    return (
        <InputWrapper>
            <TextField
                name="city"
                placeholder={intl.formatMessage({
                    id: `supplier.form.city.placeholder`,
                })}
                disabled={submitting}
                {...rest}
            />
        </InputWrapper>
    );
};

CityField.propTypes = {
    formId: PropTypes.string.isRequired,
    tabIndex: PropTypes.number.isRequired,
};

export default React.memo(CityField);
